<template>
  <b-modal
    :id="`course-is-full${id}`"
    modal-class="modal-style"
    ref="modal"
    v-model="modal"
  >
    <template>
      <p class="modal-style-title alert-title">人數已滿</p>
      <div class="modal-style-content">
        <p>很抱歉，上課人數已滿</p>
        <p>請選擇其他課程，謝謝您</p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn modal-style-single-btn" @click="closeModal()">
        確定
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      modal: false
    };
  },
  watch: {
    modal(next) {
      if (next == false) {
        this.$emit('closeModal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$bvModal.hide(`course-is-full${this.id}`);
    }
  }
};
</script>
